<template>
  <div>
    <div class="children-photos">
      <div class="row">
        <div class="col-sm-3">
          <h3 style="margin-top: 4px;">
            week {{ this.$moment(dateStart).format('W') }}
            <span v-if="$moment(dateStart).format('YYYY') !== $moment().format('YYYY')">
              {{ $moment(dateStart).format('YYYY') }}
            </span>
          </h3>
        </div>
        <div class="col-sm-9 text-end">
          <date-range-select type="week" @changeDateRange="getPhotos(selectedChild, $event.dateStart, $event.dateEnd)"></date-range-select>
        </div>
        <div class="col-12">
          <hr>
        </div>
      </div>
      <div v-if="isLoading">
        <p class="text-center" style="margin: 50px">
          Laden...
        </p>
      </div>
      <div v-else>
        <p v-if="photos.length < 1" class="text-center" style="margin: 50px">
          Geen foto's
        </p>
      </div>
      <img v-on:click="handlePhotoClick(image)" class="fit-image" v-bind:key="image.id" v-for="image in photos" :src="image.link_viewer + '?thumbnail=1&token=' + $store.getters.imageToken" height="150">
    </div>
    <div v-if="showFull">
      <div class="full" v-on:click="toggleShowFull">
        <div class="full-message">{{ image.message }}</div>
        <div class="d-flex justify-content-center">
          <img :src="image.link_viewer+ '?token=' + $store.getters.imageToken">
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import DateRangeSelect from '@/components/Date-Range-Select'
export default {
  name: 'children-photos',
  components: {
    DateRangeSelect
  },
  data () {
    return {
      isLoading: false,
      photos: [],
      dateStart: null,
      dateEnd: null,
      showFull: false
    }
  },
  methods: {
    getPhotos (child, dateStart, dateEnd) {
      this.isLoading = true
      this.dateStart = dateStart
      this.dateEnd = dateEnd
      this.photos = []
      this.$request.get('/photos?id_child=' + child.id + '&date=' + dateStart + '&up_to_date=' + dateEnd)
      .then((response) => {
        this.isLoading = false
        if (response.data) {
          this.photos = response.data
        }
      })
    },
    handlePhotoClick(image) {
        this.toggleShowFull(image)
    },
    selectPhoto(image) {
      if (this.getSelectedClass(image)) {
        this.selectedImages = this.selectedImages.filter(function (e) {
          return e.id !== image.id
        })
      } else {
        this.selectedImages.push({
          id: image.id,
          shared: image.shared
        })
      }
    },
    toggleShowFull: function (image) {
      if (this.showFull === false) {
        this.image = image
        this.showFull = true
      } else if (this.showFull === true) {
        this.image = null
        this.showFull = false
      }
      return false
    },
    getSelectedClass(image) {
      var selectedClass = ''
      for (var i = 0; i < this.selectedImages.length; i++) {
        if (this.selectedImages[i].id === image.id) {
          selectedClass = 'selected'
        }
      }
      return selectedClass
    },
  }
}
</script>

<style scoped>
  img {
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .full {
    z-index: 1000;
    background: rgba(0, 0, 0, 0.99);
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  .full img {
    margin-top: -50%;
    z-index: 1001;
    width: auto;
    max-width: 90%;
    height: auto;
    max-height: 90%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .full-message {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    color: #ffffff;
  }
</style>
